import Upload from './Upload';

export default Upload;



// WEBPACK FOOTER //
// ./src/upload/index.js